import React from "react";
import { DocumentCardProps } from "./DocumentCard.types";
import { CardContainer, DocumentTitle, IconsWrapper } from "./DocumentCard.styles";
import StatusBadge from "../StatusBadge/StatusBadge";

const DocumentCard: React.FC<DocumentCardProps> = ({
  title,
  isSubscribed,
  availabilityStatus,
  onClick,
}) => {
  const isProcessing = availabilityStatus === "processing";
  const isAvailable = availabilityStatus === "available" && isSubscribed;

  return (
    <CardContainer onClick={onClick}>
      <IconsWrapper>
        <StatusBadge
          text={isProcessing ? "На технической обработке" : isAvailable ? "Доступен" : "Недоступен"}
          variant={isProcessing ? "yellow" : isAvailable ? "green" : "red"}
        />
      </IconsWrapper>
      <DocumentTitle>{title}</DocumentTitle>
    </CardContainer>
  );
};

export default DocumentCard;
